import React from "react";
import { useState, useEffect } from "react";
// import "./task.css";
// import "./notes.css";

// const daysTag = document.querySelector(".days")
// const datess = document.querySelector(".date"),
// currentDate = document.querySelector(".current-date"),

// prevNextIcon = document.querySelectorAll(".icons span");

// // getting new date, current year and month
// let date = new Date(),
// currYear = date.getFullYear(),
// currMonth = date.getMonth();

// // storing full name of all months in array
// const months = ["January", "February", "March", "April", "May", "June", "July",
//               "August", "September", "October", "November", "December"];

// const renderCalendar = () => {
//     let firstDayofMonth = new Date(currYear, currMonth, 1).getDay(), // getting first day of month
//     lastDateofMonth = new Date(currYear, currMonth + 1, 0).getDate(), // getting last date of month
//     lastDayofMonth = new Date(currYear, currMonth, lastDateofMonth).getDay(), // getting last day of month
//     lastDateofLastMonth = new Date(currYear, currMonth, 0).getDate(); // getting last date of previous month
//     let liTag = "";

//     for (let i = firstDayofMonth; i > 0; i--) { // creating li of previous month last days
//         liTag += `<li class="inactive">${lastDateofLastMonth - i + 1}</li>`;
//     }

//     for (let i = 1; i <= lastDateofMonth; i++) { // creating li of all days of current month
//         // adding active class to li if the current day, month, and year matched
//         let isToday = i === date.getDate() && currMonth === new Date().getMonth()
//                      && currYear === new Date().getFullYear() ? "active" : "";
//         liTag += `<li class="${isToday}">${i}</li>`;
//     }

//     for (let i = lastDayofMonth; i < 6; i++) { // creating li of next month first days
//         liTag += `<li class="inactive">${i - lastDayofMonth + 1}</li>`
//     }
//     currentDate.innerText = `${months[currMonth]} ${currYear}`; // passing current mon and yr as currentDate text
//     daysTag.innerHTML = liTag;
// }

// renderCalendar();

// prevNextIcon.forEach(icon => { // getting prev and next icons
//     icon.addEventListener("click", () => { // adding click event on both icons
//         // if clicked icon is previous icon then decrement current month by 1 else increment it by 1
//         currMonth = icon.id === "prev" ? currMonth - 1 : currMonth + 1;

//         if(currMonth < 0 || currMonth > 11) { // if current month is less than 0 or greater than 11
//             // creating a new date of current year & month and pass it as date value
//             date = new Date(currYear, currMonth, new Date().getDate());
//             currYear = date.getFullYear(); // updating current year with new date year
//             currMonth = date.getMonth(); // updating current month with new date month
//         } else {
//             date = new Date(); // pass the current date as date value
//         }
//         renderCalendar(); // calling renderCalendar function
//     });
// });
var data = [
  {
    title: "",
  },
];

function Notess() {
  const [notes, setNotes] = useState("");
  const handleSubmit = () => {
    setMessege((message) => [
      ...message,
      {
        title: notes,
      },
    ]);

    data.push({
      title: notes,
    });
  };
  const [message, setMessege] = useState(data);
  const handleChange = (e) => {
    setNotes(e.target.value);
  };
  return (
    <div>
      <div className="profile-contain">
       
        <div className="profile-sec">
          <div class="linee">
            <a class="dot" href="">
              ...
            </a>{" "}
          </div>

          <span className="task-top-side"></span>
          <center>
            <span className="task-list-heading">Notes list</span>
          </center>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            fill="currentColor"
            class="bi bi-bell-fill notification"
            viewBox="0 0 16 16"
          >
            <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zm.995-14.901a1 1 0 1 0-1.99 0A5.002 5.002 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901z" />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            fill="currentColor"
            class="bi bi-trash3 trash"
            viewBox="0 0 16 16"
          >
            <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
          </svg>

          <div className="task-overflow">
            {message.map((messagess) => {
              return (
                <div className="tasks-message">
                  <div class="notes-line-1">
                    <a class="dot" href="">
                      ...
                    </a>{" "}
                  </div>
                  <span className="task-side"></span>{" "}
                  <div className="task-data task-data2">
                    {messagess.title}
                    <br></br>
                  </div>
                  <div className="task-time">2 minutes ago</div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-pencil-fill task-edit-button"
                    viewBox="0 0 16 16"
                  >
                    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                  </svg>
                </div>
              );
            })}
          </div>
          {/* <center>   <button type="submit" class="btn" >Save</button><br></br>
                       <p class="data">Your data will be updated on directory ASAP</p>
                   </center>  */}
          <div class="task-list-line">
            <p className="acc">Notes List</p>
          </div>
        </div>
        <div>
          <div className="taskS">
            <div class="linee">
              <a class="dot" href="">
                ...
              </a>{" "}
            </div>
            <div className="T-heading task-list-heading2">Notes</div>
            <div>
              <span className="">
                <input
                  className="input"
                  onChange={handleChange}
                  type="text"
                  placeholder="task-title"
                  style={{
                    width: "90%",
                    height: "47.7px",
                    background: "#FFFFFF",
                    boxShadow: " 0px 2px 2px rgba(0, 0, 0, 0.25)",
                    marginLeft: "20px",
                    borderRadius: "5px",
                    border: "none",
                    outline: "none",
                    marginTop: "20px",
                  }}
                ></input>
              </span>
              <br></br>
              {/* {
           useState.map((messageS)=>{
              return <p style={dataClass}>{messageS.messages}</p> 
            })
           }  */}
              <span className="">
                <textarea
                  placeholder="discription"
                  style={{
                    width: "90%",
                    height: "168.68px",
                    background: "#FFFFFF",
                    boxShadow: " 0px 2px 2px rgba(0, 0, 0, 0.25)",
                    borderRadius: "5px",
                    border: "none",
                    outline: "none",
                    padding: "10px",
                    marginTop: "5px",
                    marginLeft: "20px",
                  }}
                ></textarea>
              </span>

              <span className="">
                <select
                  className="select2"
                  style={{
                    width: "90%",
                    height: "47.7px",
                    background: "#FFFFFF",
                    boxShadow: " 0px 2px 2px rgba(0, 0, 0, 0.25)",
                    borderRadius: "5px",
                    border: "none",
                    outline: "none",
                    paddingLeft: "20px",
                    marginTop: "5px",
                    marginLeft: "20PX",
                  }}
                >
                  <option>set priority as</option>
                </select>
              </span>
              {/* {
           useState.map((messageS)=>{
              return <p style={dataClass}>{messageS.messages}</p> 
            })
           }  */}

              <center>
                {" "}
                <button type="button" onClick={handleSubmit} class="task-save">
                  Save
                </button>
                <button type="submit" className="task-delete">
                  Delete
                </button>
              </center>
              <div class="task-line">
                <p className="acc">Notes List</p>
              </div>
            </div>
          </div>

          <div className="dragAndDrop">
            <div class="linee">
              <a class="dot" href="">
                ...
              </a>{" "}
            </div>
            <span className="Drag-heading task-list-heading2">
              Set as remiender
            </span>
            <div className="overflow1">
              <div className="Drag-message">
                <h5>Drag and Drop to keed it as remiender</h5>
                {/* {
           useState.map((messageS)=>{
            return <p style={dataClass}> {messageS.messages}</p>
            })
           } */}
              </div>

              <center>
                {" "}
                <input
                  type="date"
                  style={{
                    background: "#FFFFFF",
                    border: "0.615385px solid   gray",

                    borderRadius: "6.15385px",
                    outline: "none",
                    padding: "10px ",
                  }}
                ></input>
                <input
                  type="time"
                  value="10:29:30"
                  style={{
                    background: "#FFFFFF",
                    border: "0.615385px solid   gray",

                    borderRadius: "6.15385px",
                    outline: "none",
                    padding: "10px ",
                    margin: "10px",
                  }}
                ></input>
                <span>
                  {" "}
                  <button
                    type="submit"
                    style={{
                      border: "none",

                      padding: "10px",

                      background: "#FFE00B",
                      width: "8.6PX",
                      borderRadius: "3px",
                      fontFamily: "Inter",
                      fontStyle: "normal",
                      fontWeight: "400",
                      fontSize: "16px",
                      lineHeight: "19px",
                      marginRight: "px",
                      color: "#121212",
                      width: "100px",
                    }}
                  >
                    set
                  </button>
                </span>
              </center>
            </div>
            <div class="Drag-line">
              <p className="acc">Reminder</p>
            </div>
          </div>
        </div>
        <div className="agile-calender-sec c-2">
          <div class="linee">
            <a class="dot" href="">
              ...
            </a>{" "}
          </div>

          <span className="rmsg task-list-heading3">calendar task list</span>
          <div className="">
            <div class="wrapper warper2">
              <header>
                <p class="current-date"></p>
                <div class="icons">
                  <span id="prev" class="material-symbols-rounded"></span>
                  <span id="next" class="material-symbols-rounded"></span>
                </div>
              </header>
              <div class="calendar">
                <ul class="weeks">
                  <li>Sun</li>
                  <li>Mon</li>
                  <li>Tue</li>
                  <li>Wed</li>
                  <li>Thu</li>
                  <li>Fri</li>
                  <li>Sat</li>
                </ul>
                <ul class="days"></ul>
              </div>
            </div>
          </div>
          <h5 className="date-heading heading-2">Date Choosen</h5>
          <h5 className="date date-2">todays date</h5>
          <div className="c-flex">
            <div>
              <div className="reminder">5</div>
              <div className="r-heading">finished</div>
            </div>
            <div>
              <div className="finished">2</div>
              <div className="f-heading">finished</div>
            </div>
            <div>
              <div className="deliverd">3</div>
              <div className="d-heading">delivered</div>
            </div>
          </div>
          <div className="overflow11">
            <div className="tasks-message task-messege2">
              <div class="notes-line-1">
                <a class="dot" href="">
                  ...
                </a>{" "}
              </div>

              <div className="task-data task-data3">
                <br></br>
              </div>
              <div className="task-time">2 minutes ago</div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                class="bi bi-pencil-fill task-edit-button"
                viewBox="0 0 16 16"
              >
                <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
              </svg>
              {/* {
           useState.map((messageS)=>{
              return <p style={dataClass}>{messageS.messages}</p> 
            })
           }  */}
            </div>

            <div className="tasks-message task-messege2">
              <div class="notes-line-1">
                <a class="dot" href="">
                  ...
                </a>{" "}
              </div>
              <div className="task-data task-data3">
                <br></br>
              </div>
              <div className="task-time">2 minutes ago</div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                class="bi bi-pencil-fill task-edit-button"
                viewBox="0 0 16 16"
              >
                <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
              </svg>
              {/* {
           useState.map((messageS)=>{
              return <p style={dataClass}>{messageS.messages}</p> 
            })
           }  */}
            </div>
          </div>

          <div class="date-bottom date-bottom2">
            <p className="datess">
              <b>calendar</b>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Notess;
